import {useTranslation} from '@/translations/i18n'
import {DetailsPageContentTabWrapper} from '@/components/ui/details-atoms/DetailsAtoms'
import {Tab, Tabs} from '@/components/ui/tab-atoms/TabAtoms'
import {routes} from '@/utilities/constants/routes'
import {StyledWrapper} from './style'
import {To} from 'react-router-dom'
import {z} from 'zod'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {ValidatorSearchParams} from '../../types'
import {useAccessesPersistantSearchParams} from '../../hooks/useAccessesSearchParams'

const AccessesSeacrhParams = ValidatorSearchParams.merge(
    z.object({
        filters: z.string().optional()
    })
)

export const AccessesTabs = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(AccessesSeacrhParams)

    const {tableSearchParams, validatorSearchParams} = useAccessesPersistantSearchParams(searchParams)

    const tabs = [
        {
            label: t('accesses:title'),
            to: {pathname: routes.ACCESSES_TABLE.handle.path, search: tableSearchParams}
        },
        {
            label: t('accesses:validator_title'),
            to: {pathname: routes.ACCESSES_VALIDATOR.handle.path, search: validatorSearchParams}
        },
        {
            label: t('activity_report:history_title'),
            to: {pathname: routes.ACTIVITY_REPORT_HISTORY.handle.path}
        }
    ] as const satisfies Array<{label: string; to: To}>

    return (
        <StyledWrapper>
            <DetailsPageContentTabWrapper>
                <Tabs paddingX={4}>
                    {tabs.map((tab, index) => (
                        <Tab key={index} to={tab.to}>
                            {tab.label}
                        </Tab>
                    ))}
                </Tabs>
            </DetailsPageContentTabWrapper>
        </StyledWrapper>
    )
}
